module.exports = __webpack_public_path__ + "img/BW.391fed6e.png";